<template>
    <div id="app">
        <div ref="container">
            <div v-for="q in currentQuestions">
                <question-type-date @saveData="saveData" @setPrevQuestion="setPrevQuestion" v-if="q.type === 'date'"
                                    :currentQuestion="currentQuestion"  :question="q"
                                    :q_length="q_length" :key="q.id"/>
                <question-type-rating @saveData="saveData" @setPrevQuestion="setPrevQuestion" v-if="q.type === 'rating'"
                                      :currentQuestion="currentQuestion" :question="q"
                                      :q_length="q_length" :key="q.id"/>
                <question-type-radio @saveData="saveData" @setPrevQuestion="setPrevQuestion" v-if="q.type === 'radio'"
                                     :currentQuestion="currentQuestion"  :question="q"
                                     :q_length="q_length" :key="q.id"/>
                <question-type-callback @saveData="saveData" @setPrevQuestion="setPrevQuestion"
                                        v-if="q.type === 'callback'" :currentQuestion="currentQuestion"
                                         :question="q" :q_length="q_length" :key="q.id"/>
                <question-type-checkbox @saveData="saveData" @setPrevQuestion="setPrevQuestion"
                                        v-if="q.type === 'checkbox'" :currentQuestion="currentQuestion"
                                         :question="q" :q_length="q_length" :key="q.id"/>
                <question-type-select @saveData="saveData" @setPrevQuestion="setPrevQuestion" v-if="q.type === 'select'"
                                      :currentQuestion="currentQuestion"  :question="q"
                                      :q_length="q_length" :key="q.id"/>
                <question-type-input @saveData="saveData" @setPrevQuestion="setPrevQuestion" v-if="q.type === 'input'"
                                     :currentQuestion="currentQuestion" :question="q"
                                     :q_length="q_length" :key="q.id"/>
                <question-type-form-step @saveData="saveData" @setPrevQuestion="setPrevQuestion"
                                         v-if="q.type === 'last_step'" :currentQuestion="currentQuestion"
                                         :contactFormDescription="contactFormDescription" :form_question="formQuestions"
                                         :q_length="q_length" :key="q.id"/>
            </div>
        </div>

        <Steps :q_length="q_length" :currentQuestion="currentQuestion"/>
    </div>
</template>


<script>
import Vue from 'vue'
import questionTypeDate from './components/type_date'
import questionTypeRating from './components/type_rating'
import questionTypeInput from './components/type_input'
import questionTypeRadio from './components/type_radio'
import questionTypeCallback from './components/type_callback'
import questionTypeCheckbox from './components/type_checkbox'
import questionTypeSelect from './components/type_select'
import questionTypeFormStep from './components/type_form_step'
import Steps from './components/steps'
import axios from 'axios'

export default {
    name: 'app',
    components: {
        questionTypeDate,
        questionTypeRating,
        questionTypeInput,
        questionTypeRadio,
        questionTypeCallback,
        questionTypeCheckbox,
        questionTypeSelect,
        questionTypeFormStep,
        Steps
    },
    data() {
        return {
            fullData: {},
            currentQuestion: -1,
            q_length: 0,
            currentQuestions: {},
            formQuestions: {},
            last_step: true,
            hasContactForm: true,
            contactFormPosition: '',
            contactFormDescription: '',
        };
    },
    methods: {
        init() {
            if (this.getFormQuestions) {
                this.formQuestions = this.getFormQuestions;
                this.hasContactForm = true;
            } else {
                this.last_step = false;
                this.hasContactForm = false;
            }

            if (this.hasContactForm) {
                this.contactFormPosition = this.getContactProps[0].position;
                this.contactFormDescription = this.getContactProps[0]['description' + locale];
                this.q_length = this.questionsList.length + 1;
            } else {
                this.q_length = this.questionsList.length;
            }

            this.setNextQuestion();
        },
        setNextQuestion() {
            this.currentQuestion++;
            this.currentQuestions = {};

            if (this.hasContactForm && this.contactFormPosition == 'first' && this.currentQuestion == 0) {
                this.$set(this.currentQuestions, 'last_step', {'type': 'last_step'});
            } else if (this.hasContactForm && this.contactFormPosition == 'end' && (this.currentQuestion == this.q_length - 1)) {
                this.$set(this.currentQuestions, 'last_step', {'type': 'last_step'});
            } else {
                if (this.contactFormPosition == 'first') {
                    this.$set(this.currentQuestions, this.questionsList[this.currentQuestion - 1].id, this.questionsList[this.currentQuestion - 1]);
                } else {
                    this.$set(this.currentQuestions, this.questionsList[this.currentQuestion].id, this.questionsList[this.currentQuestion]);
                }

            }
        },
        setPrevQuestion() {
            this.currentQuestion--;
            this.currentQuestions = {};

            if (this.hasContactForm && this.contactFormPosition == 'first' && this.currentQuestion == 0) {
                this.$set(this.currentQuestions, 'last_step', {'type': 'last_step'});
            } else if (this.hasContactForm && this.contactFormPosition == 'end' && (this.currentQuestion == this.q_length - 1)) {
                this.$set(this.currentQuestions, 'last_step', {'type': 'last_step'});
            } else {
                if (this.contactFormPosition == 'first') {
                    this.$set(this.currentQuestions, this.questionsList[this.currentQuestion - 1].id, this.questionsList[this.currentQuestion - 1]);
                } else {
                    this.$set(this.currentQuestions, this.questionsList[this.currentQuestion].id, this.questionsList[this.currentQuestion]);
                }

            }
        },
        saveData(formData) {
            this.fullData = Object.assign({}, this.fullData, formData);

            if (this.currentQuestion < this.q_length - 1) {
                this.setNextQuestion();
            } else {
                this.currentQuestions = {};
                $(".question-steps").hide();
                const urlParams = new URLSearchParams(window.location.search);
                this.fullData = Object.assign({}, {
                    'data': this.fullData,
                    '_token': token,
                    'office_id': office_id,
                    'questionare_id': questionare_id
                });
                if (urlParams.has('cid')) {
                  this.fullData.cid = urlParams.get('cid');
                }
                let axiosConfig = {
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                };

                axios.post(localeUrl + '/apply-form/questionaire', this.fullData, axiosConfig)
                    .then(function (response) {
                        console.log('response', response)
                        $('.popup .btn').text(response.data.btn_title)
                        $('.popup .btn').attr('href', response.data.btn_url)
                        $('.popup .inner-text').html(response.data.message)
                        $('.popup').show();
                    })
                    .catch(function (error) {
                        console.log(error);
                        $('.popup .btn').text(error.data.btn_title)
                        $('.popup .btn').attr('href', error.data.btn_url)
                        $('.popup .inner-text').html(error.data.message)
                        $('.popup').show();
                    });

            }
        }
    },
    computed: {
        questionsList() {
            if (dataQuestions) {
                let data = [].concat(dataQuestions.map(
                    (question) => {
                        question.title = question['title' + locale];
                        question.question_answers.forEach((qa) => qa.title = qa['title' + locale]);
                        return question;
                    }
                ));
                dataQuestions = null;
                return data;
            } else {
                return '';
            }
        },
        getContactProps() {
            if (contactForm) {
                contactForm.questions.forEach((question) => question.title = question['title' + locale]);
                console.log(contactForm);
                let data = [].concat(contactForm);
                contactForm = null;
                return data;
            } else {
                return '';
            }
        },
        getFormQuestions() {
            if (formQuestions) {
                let data = [].concat(formQuestions.map(
                    (question) => {
                        question.title = question['title' + locale];
                        return question;
                    }
                ));
                formQuestions = null;
                return data;
            } else {
                return false;
            }
        }
    },
    mounted: function () {
        this.init();
    },
}
</script>




// WEBPACK FOOTER //
// src/App.vue